import * as Yup from 'yup';

export const initialValues = {
  entity: null,
  course: null,
  unit: null,
  semester: null,
  group: null,
  local: null,
};

export const validationSchema = Yup.object({
  entity: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  course: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  semester: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  unit: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  group: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  local: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
});
